export default {
  summary_one: '{{count}} produs a fost eliminat · indisponibil pentru ora de ridicare',
  summary_few: '{{count}} produse au fost eliminate · indisponibile la ora ridicării',
  summary_other: '{{count}} produse au fost eliminate · indisponibile pentru ora de ridicare',
  reason: 'Poate fi comandat doar {{schedule}} — ridicarea ta este la {{time}}.',
  change_pickup_time: 'Schimbă ora de ridicare',
  dismiss: 'Închide',
};
